import { z } from 'zod'
import { UserRole } from '../../enums/user-role.enum'

export const featureFlagResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  description: z.string().nullable(),
  value: z.string(),
  enabled: z.boolean(),
  targetRoles: z.array(z.nativeEnum(UserRole)),
  targetUserIds: z.array(z.string().guid()),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type FeatureFlagResponseDto = z.infer<typeof featureFlagResponseSchema>

export const resolvedFlagSchema = z.object({
  enabled: z.boolean(),
  value: z.string(),
})
export type ResolvedFlag = z.infer<typeof resolvedFlagSchema>

export const resolvedFlagsResponseSchema = z.record(z.string(), resolvedFlagSchema)
export type ResolvedFlagsResponseDto = z.infer<typeof resolvedFlagsResponseSchema>
